'use client';

import dynamic from 'next/dynamic';
import { Modals } from '@/helpers/modals';
import { Modal } from '../Modal';
import { Loader } from '../profile/LoaderWrapper';
import { useDialogs, useDialogsPreloading } from './hooks';

const PRELOADED_MODALS = [Modals.Registration, Modals.Login];

const Dialogs: React.FC = () => {
  const { modal } = useDialogs();

  const modalsCache = useDialogsPreloading<object>(PRELOADED_MODALS);

  if (modal) {
    if (!modalsCache.has(modal)) {
      modalsCache.set(
        modal,
        dynamic<object>(() => import(`@/components/dialogs/${modal}`), {
          ssr: false,
          loading: () => <Loader size={50} />,
        })
      );
    }

    const Component = modalsCache.get(modal)!;

    return (
      <Modal>
        <Component />
      </Modal>
    );
  }
  return null;
};

export default Dialogs;
